import { observer } from 'mobx-react-lite'
import { NumberRangeFilterView } from '@/components/FilterControls/NumberRange'
import { type NumberRangeFilter } from '@/infra/NumberRangeFilter'

interface NumberRangeFilterViewContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: NumberRangeFilter<keyof TFilters>
  currencyCode: string
  unitName: string
  testId?: string
}

/**
 * Editor for a {@link NumberRangeFilter}.
 */
export const NumberRangeFilterViewContainer = observer(
  function NumberRangeFilterViewContainer<
    TFilters extends Record<string, unknown>,
  >({
    filter,
    currencyCode,
    unitName,
    testId,
  }: NumberRangeFilterViewContainerProps<TFilters>) {
    return (
      <NumberRangeFilterView
        title={filter.title}
        min={filter.value?.min}
        max={filter.value?.max}
        onMinChange={filter.setMin}
        onMaxChange={filter.setMax}
        onClear={filter.clear}
        currencyCode={currencyCode}
        unitName={unitName}
        testId={testId}
      />
    )
  },
)
